export const digitalBooksLinks = [
  {
    "Nombre": "Matemática básica para ingeniería agronómica e ing. Forestal",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/1d3qtdplSiEhHfapFN4sNW_N-KKyl0l3-/view?usp=drive_link"
  },
  {
    "Nombre": "Introducción al análisis matemático (cálculo II) - Rabuffeti",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/1fw8i-rEvxhV8-QZG-c5owGWQ7J4Dzg11/view?usp=drive_link"
  },
  {
    "Nombre": "Introducción al análisis matemático (cálculo I) - Rabuffeti",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/15s3J6ud5MwOj3HCkkljAifrDZoZ2c52L/view?usp=drive_link"
  },
  {
    "Nombre": "Álgebra I - Rojo",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/1d3qtdplSiEhHfapFN4sNW_N-KKyl0l3-/view?usp=drive_link"
  },
  {
    "Nombre": "Álgebra II - Rojo",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/1XEwyN-07oFCl2uJQKqUwUckodmNJTr91/view?usp=drive_link"
  },
  {
    "Nombre": "SD-19: Lógica preposicional",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/1F-W_Tq1PXHuvM4gHllrfli7lIQrNwLWW/view?usp=drive_link"
  },
  {
    "Nombre": "SD-38: Ecuaciones lineales",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/1DCStxMC6zD4Qp3ApXh9htg5PEA39pXrc/view?usp=drive_link"
  },
  {
    "Nombre": "SD-37: Álgebra vectorial",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/1zg-xTjmrHedx8HurothnzW_5DD0QgUjo/view?usp=drive_link"
  },
  {
    "Nombre": "SD-11: Ecuaciones diferenciales",
    "Materia": "ÁLGEBRA Y CÁLCULO",
    "Link": "https://drive.google.com/file/d/1Bntn3Hk1XAWviCcFILNQvSK0Q2xRagVK/view?usp=drive_link"
  },
  {
    "Nombre": "Guías de prácticas sustentables para las áreas forestales de la provincia de Santiago del Estero",
    "Materia": "APROVECHAMIENTO",
    "Link": "https://drive.google.com/file/d/161yERvxr7cyunkj0qswP4MNQj_IJcOAn/view?usp=drive_link"
  },
  {
    "Nombre": "Aprovechamiento forestal: análisis de apeo y transporte",
    "Materia": "APROVECHAMIENTO",
    "Link": "https://drive.google.com/file/d/1y6Sgos9W9KuuwVkWmE3jCPNU5VbTwFMW/view?usp=drive_link"
  },
  {
    "Nombre": "Viología de los animales",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1E9_llCOdUtm2XmWDJYEjvGdV0kmI4crN/view?usp=drive_link"
  },
  {
    "Nombre": "Fisiología vegetal - Cortez",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1uPlkCkGuy5QEtOHo0HiuCOGxOjuUTHaR/view?usp=drive_link"
  },
  {
    "Nombre": "Morfología de la raíz",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1oJV0Bs8oUUud182tEfbLEwcgxq4Vwuy4/view?usp=drive_link"
  },
  {
    "Nombre": "El reino vegetal",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1jyBgrFgq3XLY3wBHzBxKqlKP7rY-xYTk/view?usp=drive_link"
  },
  {
    "Nombre": "Fisiologíia vegetal",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1Dc_BH2L3XCCHe6nKYEeOnuSBuNooM-Tp/view?usp=drive_link"
  },
  {
    "Nombre": "Morfología de las plantas superiores",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1opdKISJSfjN_awt3-3zFv1ODT4TLdie-/view?usp=drive_link"
  },
  {
    "Nombre": "La célula",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1NK5XMdEPPwrAXu3-2igLT3QA1txF9dJB/view?usp=drive_link"
  },
  {
    "Nombre": "Atlas de anatomía vegetal",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1NNY7SrGpvRPHDbmOMUxeUQ9rK3KEq_5e/view?usp=drive_link"
  },
  {
    "Nombre": "Botánica, morfología, taxonomía y fitogeografía",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1lMZN8Gf8pD9Od7MntHlovzLqFlUdYkxb/view?usp=drive_link"
  },
  {
    "Nombre": "Biología: la unidad uy la diversidad de la vida",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1r2YGZJQS9vl7hAUC8uVg-dHrKU1GaJl_/view?usp=drive_link"
  },
  {
    "Nombre": "Tratado de histología",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1ECmTw3qwWRtns4ZvX5i-M9Vq5FBXyOjb/view?usp=drive_link"
  },
  {
    "Nombre": "Fisiología vegetal -  Barceló",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1ZhunWocmxb0ruRiyKwR_a_tUCwlP7uMR/view?usp=drive_link"
  },
  {
    "Nombre": "Biología Curtis",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1sxOWkMRSBb43T1mSTggbSy0uuG9SN2cB/view?usp=drive_link"
  },
  {
    "Nombre": "Anatomía vegetal",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1ionmtjeDW-N-2csmdZMrqz9XpmL54ywM/view?usp=drive_link"
  },
  {
    "Nombre": "Biología celular y molecular",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1XPKJN5QtNkS0ZMUmbdzptOAjTaUAzCu7/view?usp=drive_link"
  },
  {
    "Nombre": "Tratado de botánica",
    "Materia": "BIOLOGÍA Y FISIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1hRMRldqWzzy5MGdYuSonZlFPTtJwuuHs/view?usp=drive_link"
  },
  {
    "Nombre": "Plantas vasculares de la Argentna: nativas y exóticas",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1Zeisaf2fSPA3kXyULNlBN931O40_S8Rv/view?usp=drive_link"
  },
  {
    "Nombre": "Enciclopedia Argentina de agricultura y jardinería -  volumen 2 -tomo I",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1pL1rPaUHQpCUVyJwkz3DBvz7z8M3FqCV/view?usp=drive_link"
  },
  {
    "Nombre": "Enciclopedia Argentina de agricultura y jardinería -  volumen 2 -tomo I",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1KABrzwSaH3D6ZEnGaZWwVIxl_AIsKCwM/view?usp=drive_link"
  },
  {
    "Nombre": "Árboles nativos de Argentina: centro y cuyo",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/15hMP7MSJdR0vvIDwnH0Z1VdLzhV0jsr8/view?usp=drive_link"
  },
  {
    "Nombre": "Pinos ornamentales y forestales",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1xu9_V3skccOptPYduitpd3NYYMyeQH4Q/view?usp=drive_link"
  },
  {
    "Nombre": "Cactaceas de Santiago del Estero",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1HwsRCuoKIvlJpMJxSUEg6AOaVTetJwEn/view?usp=drive_link"
  },
  {
    "Nombre": "Enciclopedia Argentina de agricultura y jardinería -  volumen 2 -tomo II",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/14Dzqh3xqP2B12djACVDc60nqaZ55vhxm/view?usp=drive_link"
  },
  {
    "Nombre": "Catálogo de las plantas vasculares de la República Argentina II",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/16TwZJL79qpwCX00sagM-j-UhzJgr32aH/view?usp=drive_link"
  },
  {
    "Nombre": "Enciclopedia Argentina de agricultura y jardinería -Volumen 1 ",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1TYuxwGfn6eXH3jNt3tBM-TJhBGd4xGb1/view?usp=drive_link"
  },
  {
    "Nombre": "Tratado de botánica",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1xCYmIvNf4sKFkokF3NFl3gyjWwPsGzxQ/view?usp=drive_link"
  },
  {
    "Nombre": "Nociones básicas de taxonomía vegetal",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1-x0P8Llk2SMP82pTM44U6jMaORMH9Phd/view?usp=drive_link"
  },
  {
    "Nombre": "Atlas de los bosques nativos argentinos",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/14XaM3h-5Kaht9qB8jfQ_5fmyO3Z9w0tJ/view?usp=drive_link"
  },
  {
    "Nombre": "Palmeras Argentinas",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1JBCYf_bMEdJgfYDHwWD4CsxVctP-VyF0/view?usp=drive_link"
  },
  {
    "Nombre": "Frutos de leñosas nativas argentinas",
    "Materia": "BOTÁNICA SISTEMÁTICA",
    "Link": "https://drive.google.com/file/d/1NC4bBQLqqu1RFMTb9asqxbBFPCYM7rmt/view?usp=drive_link"
  },
  {
    "Nombre": "Climatología general y agrícola en SDE",
    "Materia": "CLIMATOLOGÍA",
    "Link": "https://drive.google.com/file/d/1vJj4mM4xy_BCvJSvtBFXgGpt6Wl9rUoc/view?usp=drive_link"
  },
  {
    "Nombre": "Análisis de las características climáticas de la provincia de SDE",
    "Materia": "CLIMATOLOGÍA",
    "Link": "https://drive.google.com/file/d/1hPqr1jiBFYbllVeM4z7cPOG-F6V57ner/view?usp=drive_link"
  },
  {
    "Nombre": "Iniciación a la meterológica agrícola",
    "Materia": "CLIMATOLOGÍA",
    "Link": "https://drive.google.com/file/d/1evuwESIIXf15Vrx0CRsyjSX3oQKNKDKf/view?usp=drive_link"
  },
  {
    "Nombre": "Agrometereología",
    "Materia": "CLIMATOLOGÍA",
    "Link": "https://drive.google.com/file/d/1mIPXjEJQ07tfsudyo478UYz8wIfr3pwx/view?usp=drive_link"
  },
  {
    "Nombre": "Climatología y fenología agrícolas",
    "Materia": "CLIMATOLOGÍA",
    "Link": "https://drive.google.com/file/d/15hTVNUXSsKSjwpw31-_7fT7osTDxQR4e/view?usp=drive_link"
  },
  {
    "Nombre": "Fundamentos de la conservación biológica - perspectivas latinoamericanas",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/12vv77bmxoRcMucaAwDaNgrzeCXte9Myx/view?usp=drive_link"
  },
  {
    "Nombre": "Manejo de fauna silvestre en la Argentina - programas de uso sustentable",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1f_HgdKAM5KkhP-h7RdhguV1Eu3HiR53h/view?usp=drive_link"
  },
  {
    "Nombre": "Métodos para medir la biodiversidad",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1lRHwvM5tW3VbZWAXMdI29UGR65ZjZ01P/view?usp=drive_link"
  },
  {
    "Nombre": "Manejo de áreas protegidas en los trópicos",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1nUvjfR7VddcTsha4-gHQrhFRwLkbDT77/view?usp=drive_link"
  },
  {
    "Nombre": "Planificación de parques nacionales para el desarrollo en Latinoamérica",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1D254PS-8J5lZkhXE93OaIOkot4OzMnYA/view?usp=drive_link"
  },
  {
    "Nombre": "Anales de parques nacionales",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1etJtpuFqQP1S9pkYw69AoXa1Lcfji-nI/view?usp=drive_link"
  },
  {
    "Nombre": "La conservación de la naturaleza: parques nacionales argentinos",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1XOINStxB_zQk_R_IqHPmQ4YtHj5hDg0Q/view?usp=drive_link"
  },
  {
    "Nombre": "Conservación de la biodiversidad y manejo de áreas protegidas - guía de TP",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1Ba7PCyRjiTcQCVV5kN2_wQGKeCmiJyMw/view?usp=drive_link"
  },
  {
    "Nombre": "Fauna y sociedad en Argentina: nuestros compatriotas silvestres",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/12QXj5awGam3n4LNiHoCWkI4ld2diH9JD/view?usp=drive_link"
  },
  {
    "Nombre": "El sistema nacional de áreas naturales protegidas de la república argentina",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1dyPincu0zCFnEV3FzUhdP1N6YABgKkYB/view?usp=drive_link"
  },
  {
    "Nombre": "La extinción de las especies- evolución causa y efectos",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1CPlmwdAuFrs13JpC0kRn-Ba7AZXa_l1U/view?usp=drive_link"
  },
  {
    "Nombre": "Los que se van",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1U1RBI55KfgcUB_GC6KwR9BNLxUU31KKV/view?usp=drive_link"
  },
  {
    "Nombre": "Ciencia ambiental - Desarrollo sostenible, un enfoque integral",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1bGyzDA3DD2bBTDtp0Km2qHykzJf3j6eC/view?usp=drive_link"
  },
  {
    "Nombre": "Taller de capacitación para la conservación del tapir y el pecarí labiado",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1Mao7uMu0-dVe-s7bHZCrQ-tP6OYqcW3l/view?usp=drive_link"
  },
  {
    "Nombre": "Restauración de Ríos y riberas",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1KWKAY_bTfsQqn_tW3Zlubsimw3VYquBy/view?usp=drive_link"
  },
  {
    "Nombre": "Atlas de los bosques nativos argentinos",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1AbYKXMzcHiu1ud1ogLb3L8vhkczFCMaF/view?usp=drive_link"
  },
  {
    "Nombre": "Mapa forestal de la provincia de SDE",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1ySaDfpNNbUh5LKqofBMgpv4EqIJFYcnM/view?usp=drive_link"
  },
  {
    "Nombre": "Conservación de la biodiversidad y manejo de áreas protegidas - 2016",
    "Materia": "CONSERVACIÓN Y ÁREAS PROTEGIDAS",
    "Link": "https://drive.google.com/file/d/1BeUALm3h7MSeWZD05kbE0jl13r7dGpIc/view?usp=drive_link"
  },
  {
    "Nombre": "Stimating wildlife habitat variables",
    "Materia": "DASOMETRÍA",
    "Link": "https://drive.google.com/file/d/1RzmGGb-Jbqzhz-eeBz6cVxVZ3rXN_wx7/view?usp=drive_link"
  },
  {
    "Nombre": "Modelización del crecimiento y la evolución de bosques",
    "Materia": "DASOMETRÍA",
    "Link": "https://drive.google.com/file/d/13vEqZrlIJ38oLQgrF9Skacj1AHaEvKi_/view?usp=drive_link"
  },
  {
    "Nombre": "Dasometría, parte I",
    "Materia": "DASOMETRÍA",
    "Link": "https://drive.google.com/file/d/1fBu7prt1xs2mefZTlQb-PgxSzlgeYIXL/view?usp=drive_link"
  },
  {
    "Nombre": "Dasometría en el ámbito forestal",
    "Materia": "DASOMETRÍA",
    "Link": "https://drive.google.com/file/d/1Yu6gFEbEQ91Z0pXYWgBHgdcPy_jm0LWu/view?usp=drive_link"
  },
  {
    "Nombre": "Dasometría, parte II",
    "Materia": "DASOMETRÍA",
    "Link": "https://drive.google.com/file/d/1oi1fy4mpW9pWSeDx5Ya9QH2jq9j7z1H4/view?usp=drive_link"
  },
  {
    "Nombre": "SD-41: Dendrología",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1KBl-iuNZSVW_NMRMSACCv4MMjSCHoHKf/view?usp=drive_link"
  },
  {
    "Nombre": "Educación e investigación forestal",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1N9691Y1qo0fiFJ7cQDuOrYLg1YeDjFAH/view?usp=drive_link"
  },
  {
    "Nombre": "Árboles de interés forestal y ordenamiento para noroeste argentino",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1dYUrc4p-J_0OOKDLRNWzPH3H45-JGBtO/view?usp=drive_link"
  },
  {
    "Nombre": "Anatomía de la madera",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1y6xOfKsJLeffQUWVcoqn9Le7wILPzDt0/view?usp=drive_link"
  },
  {
    "Nombre": "Enciclopedia Argentina: Regiones fitogeográficas Argentinas",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1oBsbcrQTwIAVoHaL0Qp0Y3MuIraLrGoE/view?usp=drive_link"
  },
  {
    "Nombre": "El nuevo libro del árbol - tomo 1",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1AHC90iQYzADGqfJEr7hIZU1kg3K8X337/view?usp=drive_link"
  },
  {
    "Nombre": "Árboles del chaco argentino - guía para el reconocimiento dendrológico",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1nShEuJmMa26D24hIYkYpd604nolHklQb/view?usp=drive_link"
  },
  {
    "Nombre": "Máderas y bosques argentinos - tomo 2",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1Vb3HQXguDM8t_8w-DIjHgIyN1Q_82Ill/view?usp=drive_link"
  },
  {
    "Nombre": "Máderas y bosques argentinos - tomo 1",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1i4Gb0IjzoWqNA8sgblM1n1OQPdujCArb/view?usp=drive_link"
  },
  {
    "Nombre": "Anomalías y defecto de la madera en rollo",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1BLnplIynOQfBcaB-Jez-nhQOqrK36QWQ/view?usp=drive_link"
  },
  {
    "Nombre": "Macroscoía de la madera",
    "Materia": "DENDROLOGÍA",
    "Link": "https://drive.google.com/file/d/1R4VCWpG9ArgedqP0yk-UlSZeMayUGprN/view?usp=drive_link"
  },
  {
    "Nombre": "El enfoque de los sistemas",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1gv3WrnHH5did7Xt_HkrollWHreTPzAPi/view?usp=drive_link"
  },
  {
    "Nombre": "SD-49: Fundamentos de la ecología",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1UVAeU2okZmQ6VrddSJ-6937uvulVj2Oh/view?usp=drive_link"
  },
  {
    "Nombre": "Propiedades de las poblaciones",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1sWG0vF-ilGiE-9ydNbJph1gsZx0gGVlU/view?usp=drive_link"
  },
  {
    "Nombre": "La guía del ecoturismo",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1HiZ77FsBddLu3eVLiD_w1jmjFhjcYLIP/view?usp=drive_link"
  },
  {
    "Nombre": "Los Sistemas ecológicos y la humanidad",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1m8MYCyHv8xVDM4A9I1MGUMBtA5CsZ1B-/view?usp=drive_link"
  },
  {
    "Nombre": "Cambios y problemas ambientales: perspectivas para la acción",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1WKZen8smJ6DMU6O1MVzy5J6Qr5KWtL5A/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología de la vegetación",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1_bvE-7F5rUIDKx6nWAWgq09EMmktVh3f/view?usp=drive_link"
  },
  {
    "Nombre": "Análisis de la comunidades ecológicas",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1yn0JJmEda-j8djo3fxGr9JfJ6__D9HnT/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología 1 -módulo 1",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1blJPiLJXSTxC4JbKnGHbwo2e1pvKailK/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología y ambiente",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1vYWAOq6Zf-EHpU_gwk-ZBiH_dlYpHCdg/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología Smith",
    "Materia": "ECOLOGÍA I",
    "Link": "https://drive.google.com/file/d/1e5P06n6CYH29BhECCjdi7-gUIF7P05yD/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología II: apuntes módulo 1",
    "Materia": "ECOLOGÍA II",
    "Link": "https://drive.google.com/file/d/1neCy0Ds20heY7CtKkl9gWOLKBUUWe0dn/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología II: apuntes módulo 2",
    "Materia": "ECOLOGÍA II",
    "Link": "https://drive.google.com/file/d/1N1IYjL4zj-jyLA5xxAXoafQxW56VA-w0/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología II: apuntes módulo 4",
    "Materia": "ECOLOGÍA II",
    "Link": "https://drive.google.com/file/d/1t-Pj1m5wl1kUL4W8n-jajgEaU0IEZVdi/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología II: apuntes módulo 3",
    "Materia": "ECOLOGÍA II",
    "Link": "https://drive.google.com/file/d/1i8T-ie1eCfoL01NZyT2CIvaNd4dmQq9q/view?usp=drive_link"
  },
  {
    "Nombre": "Economía ambiental - unidad 1",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1TnkkDMhJvIlDMdgXrCWnTtnAjIUhUNVi/view?usp=drive_link"
  },
  {
    "Nombre": "Administración de empresas forestales - principios básicos",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1bHaXsr1nryKpOm5-uEihB0RRNxTXYGih/view?usp=drive_link"
  },
  {
    "Nombre": "Economía ambiental: una introducción",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1R8jNP12dqUVWuxiznsACpTSoUOOOYlJY/view?usp=drive_link"
  },
  {
    "Nombre": "Alianzas forestales empresa-comunidad",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1Y_QWSDEBMkZOgNoQr-vV2-ufVMTwzHjk/view?usp=drive_link"
  },
  {
    "Nombre": "Los ecosistemas y la ecósfera",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1yuzgXyzUWyYdIoAzCNnBOPM4zee4UxwI/view?usp=drive_link"
  },
  {
    "Nombre": "Economía ambiental Oxford",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/10rIKf6FzGZSHr7lno1rQHHABn36uyWY_/view?usp=drive_link"
  },
  {
    "Nombre": "Elementos de micro y macroenomia - Francisco eggers",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1G33k4JPxAm15siKtUPZkdYIWibJgsO7X/view?usp=drive_link"
  },
  {
    "Nombre": "Elementos de micro y macroenomia - Mochon y beker",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1Nt3xYe-JXlXDis7r-MOjH60SMpN0w58g/view?usp=drive_link"
  },
  {
    "Nombre": "SD-9: Conceptos de economía",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1g4Cnx0LjrqDHBiIqkQdOqJhBsC4E6acc/view?usp=drive_link"
  },
  {
    "Nombre": "SD-10: La programación lineal aplicada al manejo forestal",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1izwmrfReddaoIuaYQcvMsYXbeN2WDm7y/view?usp=drive_link"
  },
  {
    "Nombre": "SD_13: Decisiones financieras: teoría",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1auUpICwoUl9WaWhumZnc9q30ERSXbpVe/view?usp=drive_link"
  },
  {
    "Nombre": "SD-14: Decisiones financieras: práctica",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1D4yi_CYtrpNo7Xdi70AOdsZXxsM7iSvk/view?usp=drive_link"
  },
  {
    "Nombre": "SD-30: Costos forestales",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1HAGfrp5KdVOdmTxj_7cLKbhF9jTPMlHL/view?usp=drive_link"
  },
  {
    "Nombre": "SD-40: elementos de economía",
    "Materia": "ECONOMÍA",
    "Link": "https://drive.google.com/file/d/1MQe_o5Sbkvgr64WXQCJCsvgMkIC5XuPy/view?usp=drive_link"
  },
  {
    "Nombre": "Biología y ecología de la fauna del suelo",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1AmiXjLONtmOH5VriM6y7T0fM7nyxeRQ_/view?usp=drive_link"
  },
  {
    "Nombre": "Apuntes de edafología forestal",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1GbgrDs3iPcl2sCQpIsZAi9aYt9Wjr0VS/view?usp=drive_link"
  },
  {
    "Nombre": "Manual de edafología - Duchafour",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1mSjwoyQfJDJJJidSgfbDywVS4scZH2-L/view?usp=drive_link"
  },
  {
    "Nombre": "Gupia de descripción de perfiles del suelo",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/14K5Fl-hiUuymzKGsJWHNOPYvdGrw_T7N/view?usp=drive_link"
  },
  {
    "Nombre": "Suelos, su formación, clasificación y distribución",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1anYXi1Vy6enQ6YoHXy3C-uD5wGdQjbng/view?usp=drive_link"
  },
  {
    "Nombre": "Atlas de biodiversidad del suelo",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1C135AM7ThA4YR02NBGk-zEeIb-SJHX32/view?usp=drive_link"
  },
  {
    "Nombre": "SD-12: métodos de análisis de suelos",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1lTrARWAq_iteNWdII7d5UKgbYRKqaw1C/view?usp=drive_link"
  },
  {
    "Nombre": "Mapa de suelos FAO",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1b4P4tJRW2182xghDBarNoFXw-kjZia6-/view?usp=drive_link"
  },
  {
    "Nombre": "Mapa de ecoregiones Argentinas",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1-UvXKwDMJvcQtzOKwVwbBqB_NeZsaIrd/view?usp=drive_link"
  },
  {
    "Nombre": "SD-8: Evluación ecológica de suelos",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/file/d/1is6GGsg_T-lwi1fITEoGiD5DJwNkun1U/view?usp=drive_link"
  },
  {
    "Nombre": "Diapositivas",
    "Materia": "EDAFOLOGÍA",
    "Link": "https://drive.google.com/drive/folders/1Mm_CTZSX6n_C1wsUMjxL7XFmFZKdBXHC?usp=drive_link"
  },
  {
    "Nombre": "Formulación y evaluación de proyectos",
    "Materia": "EIA",
    "Link": "https://drive.google.com/file/d/1Ao5cLRltbh2h4nXTXPSvEYIPoEQ3qyi_/view?usp=sharing"
  },
  {
    "Nombre": "manual de métodos básicos de muestreo",
    "Materia": "EIA",
    "Link": "https://drive.google.com/file/d/1xYnt1hEh5bSHxSqKWTENV7Kgdqz5-IVD/view?usp=drive_link"
  },
  {
    "Nombre": "El uso multiple o manejo integrado de los ecossitemas forestales en la evaluación del impacto ambiental",
    "Materia": "EIA",
    "Link": "https://drive.google.com/file/d/1aCJU9ptji6rdebeJWNYBJP_IYjdkK4f1/view?usp=drive_link"
  },
  {
    "Nombre": "Taller de metodologías de evaluación de impacto ambiental y desarrollo sustentable",
    "Materia": "EIA",
    "Link": "https://drive.google.com/file/d/13sz6nXL3wl-jpQWUkwyAGmnFsB4Jbk-u/view?usp=drive_link"
  },
  {
    "Nombre": "Estadística - tomo 1",
    "Materia": "ESTADÍSTICA",
    "Link": "https://drive.google.com/file/d/1gIE9vn7YEkAXP_f2jy9jSXUHgOumBpHP/view?usp=drive_link"
  },
  {
    "Nombre": "InfoStat manual de usuario",
    "Materia": "ESTADÍSTICA",
    "Link": "https://drive.google.com/file/d/1SNillWciKrF5ux5nlFqe37jBF9B3j5yo/view?usp=drive_link"
  },
  {
    "Nombre": "Métodos estadísticos elementales para técnicos forestales",
    "Materia": "ESTADÍSTICA",
    "Link": "https://drive.google.com/file/d/19Bf8R-goInK13hgueBty1X568lrU2cz0/view?usp=drive_link"
  },
  {
    "Nombre": "Introducción a la bioestadística: Aplicaciones en Infostat en agronomía",
    "Materia": "ESTADÍSTICA",
    "Link": "https://drive.google.com/file/d/1z6zdyzwcqPuchiHfW84lx4K3L3U5OrGp/view?usp=drive_link"
  },
  {
    "Nombre": "SD-5: Conceptos básicos sobre análisis de la variancia y diseño experimental",
    "Materia": "ESTADÍSTICA",
    "Link": "https://drive.google.com/file/d/1bp45RtlKL0gY6AnVXYlcvHSYuCS1teCZ/view?usp=drive_link"
  },
  {
    "Nombre": "SD-7: elementos de estadística",
    "Materia": "ESTADÍSTICA",
    "Link": "https://drive.google.com/file/d/1aVxISDub7slZ7zMcVhJiulG56xMFHc-6/view?usp=drive_link"
  },
  {
    "Nombre": "SD-21: Análisis de la variancia en experimentos factoriales",
    "Materia": "ESTADÍSTICA",
    "Link": "https://drive.google.com/file/d/1biC_42GDRxGY9FV0Ce6b4oLUSBtOWll7/view?usp=drive_link"
  },
  {
    "Nombre": "Física para la ciencia y la tecnología - Tipler",
    "Materia": "FÍSICA",
    "Link": "https://drive.google.com/file/d/15rzZIuwwWKylAFTi042qQ1TyhbkABXvK/view?usp=drive_link"
  },
  {
    "Nombre": "Fisica cinemática Rossi",
    "Materia": "FÍSICA",
    "Link": "https://drive.google.com/file/d/1bcRHJHL2x3JZXX7jGX6RCADTz8FrWkEA/view?usp=drive_link"
  },
  {
    "Nombre": "Física - Krane vol 2",
    "Materia": "FÍSICA",
    "Link": "https://drive.google.com/file/d/15Cge_X8c0HEeq4ezwM2yHq1Cq47aGntj/view?usp=drive_link"
  },
  {
    "Nombre": "Física - Krane vol 1",
    "Materia": "FÍSICA",
    "Link": "https://drive.google.com/file/d/1daLo4Gxe3prkYmEPlIG2NThPtD6iV35z/view?usp=drive_link"
  },
  {
    "Nombre": "Física universitaria - Vol II - Sears",
    "Materia": "FÍSICA",
    "Link": "https://drive.google.com/file/d/1f2VSfRjo_4JSuc7pUfM1sPUvrmcUkj0g/view?usp=drive_link"
  },
  {
    "Nombre": "Física universitaria - Vol I - Sears",
    "Materia": "FÍSICA",
    "Link": "https://drive.google.com/file/d/1PiAVT1ZV_xMl-uVLCjgi0AiHdSovMeHv/view?usp=drive_link"
  },
  {
    "Nombre": "Fitopatología  - Agrios",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1KekftfthzBvCfNO3pQWpUW8ILWOYeHRw/view?usp=drive_link"
  },
  {
    "Nombre": "Patología forestal",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1N945YNPb1buGZ8ofW2RZDgqh4HjIizV8/view?usp=drive_link"
  },
  {
    "Nombre": "Introducción a la terapeútica vegetal",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1DiA3X3K1li6SNzBK1b2z2YncVygyn_uo/view?usp=drive_link"
  },
  {
    "Nombre": "Soluciones contra plagas y enfermedades de las plantas",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1RTYWEeu1Cm881Ppvo8ZS1F2s5EnY9DRM/view?usp=drive_link"
  },
  {
    "Nombre": "Manejo de plagas producidas por insectos forestales",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/10QqE92CWXZm6B99zyPPqcAk5wEewe3Dm/view?usp=drive_link"
  },
  {
    "Nombre": "Guia de trabajos prácticos de entomología",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1tS6Kk1x_-0RpzTl2qSA0TUbceZn_XkSS/view?usp=drive_link"
  },
  {
    "Nombre": "Patología vegetal",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1SIGQ0jFDAL2NZ2_GpqB9z1WwOJU-JoOJ/view?usp=drive_link"
  },
  {
    "Nombre": "Enciclopedia de plagas y enfermedades",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1lKD05gVDJRmksfgGb46_wzbQa3GxuuHm/view?usp=drive_link"
  },
  {
    "Nombre": "SD-53: técnicas de laboratorio",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1tzy0udjmUbi05To_7gtutskWxzUilduM/view?usp=drive_link"
  },
  {
    "Nombre": "Apuntes de patología vegetal",
    "Materia": "FITOPATOLOGÍA Y ENTOMOLOGÍA",
    "Link": "https://drive.google.com/file/d/1InuL7-fC9YNBZShluzLyqS6ELADkNJIw/view?usp=drive_link"
  },
  {
    "Nombre": "Geomorfología",
    "Materia": "GEOLOGÍA",
    "Link": "https://drive.google.com/file/d/1ZQCL07ApjlmjoN7IM4OLK3EiR7lZgcvI/view?usp=drive_link"
  },
  {
    "Nombre": "Elementos de la geología aplicada",
    "Materia": "GEOLOGÍA",
    "Link": "https://drive.google.com/file/d/1NfBRRb6mZqDajgU8KhikjvAfdSb9uhK0/view?usp=drive_link"
  },
  {
    "Nombre": "Ciencias de la tierra",
    "Materia": "GEOLOGÍA",
    "Link": "https://drive.google.com/file/d/181hZnO8hjYGHWxz_RBiqWxv4Na62Yzl9/view?usp=drive_link"
  },
  {
    "Nombre": "Topografía general y aplicada",
    "Materia": "GEOLOGÍA",
    "Link": ""
  },
  {
    "Nombre": "Manual de mineralogía",
    "Materia": "GEOLOGÍA",
    "Link": "https://drive.google.com/file/d/1oNNNwdVQxj0uBAH1-l0J9Y40xM6-cR7d/view?usp=drive_link"
  },
  {
    "Nombre": "SD-42: Gestión y auditorias ambientales",
    "Materia": "GESTIÓN AMBIENTAL",
    "Link": "https://drive.google.com/file/d/1vd1pklX9XR1bDTIHnDxPOGpgfJ3uaD-w/view?usp=drive_link"
  },
  {
    "Nombre": "Principios de la hidraúlica torrencial",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1Wvgat8WwGh07xDBCgC-NvzdLbfG0SaJj/view?usp=drive_link"
  },
  {
    "Nombre": "Método de riego - módulo 1: hidraúlica",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/13tbY8kUL47IdnK0znPmP9q0HCfLPMnpC/view?usp=drive_link"
  },
  {
    "Nombre": "Método de riego - módulo 2: calidad del agua",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/17QUOKKOOLd7h51D5xTozXb4aNyvx6YHp/view?usp=drive_link"
  },
  {
    "Nombre": "Método de riego - módulo 3: superficie",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1k0e6-Nhr9FgqvCI7lBVCH3M9Jq9ghkOI/view?usp=drive_link"
  },
  {
    "Nombre": "Método de riego - módulo 4: aspersión",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1xXLXNyAPHfr25ztk2UNX9Sety6rngh2F/view?usp=drive_link"
  },
  {
    "Nombre": "Método de riego - módulo 5: goteo",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1_f72_YqibEVW_SgPS4g-Szo4CXpQWNw1/view?usp=drive_link"
  },
  {
    "Nombre": "Método de riego - módulo 1: relación agua suelo y cultivo",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1VTQM8LRidC4L-uWfMhIE4KjmwSNXu_62/view?usp=drive_link"
  },
  {
    "Nombre": "Tratamiento de aguas residuales",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1TIQ1Caz00qYByJ26RHquTkRp8hUzM9lp/view?usp=drive_link"
  },
  {
    "Nombre": "Restauración de Ríos y riberas",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1GwJS9TnnSGsuxJzLBn3Myh-JlLvav5-U/view?usp=drive_link"
  },
  {
    "Nombre": "Escalas para peces - Azagra",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1omQiRQDpfNloO89oPVcduMS6yjo1TJXg/view?usp=drive_link"
  },
  {
    "Nombre": "Hidrología en la ingeniería",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1q_nS7dpyj9mVtPSuq4JxUeOp7xkZ4NRL/view?usp=drive_link"
  },
  {
    "Nombre": "La restauración hidrológico-forestal en la cuencas hidrográficas",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1Ns2B5_vukh5AgjGiiExcS5LN8ak3RCWh/view?usp=drive_link"
  },
  {
    "Nombre": "Hidráulica y máquinas hidráulicas -facorro ruiz",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/16ml3S_xIe7Xb5wL3OwXMHFj0M0YtT_qR/view?usp=drive_link"
  },
  {
    "Nombre": "Hidráulica y máquinas hidráulicas -cesarini",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1qJf4a6Lt2GRRcPaDh2f9oLvYPKlTdFTv/view?usp=drive_link"
  },
  {
    "Nombre": "Evaluación de los recursos hídricos",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1ljZYyVgUero_IYZL8HKth0WVywDt4BEl/view?usp=drive_link"
  },
  {
    "Nombre": "Acceder al agua: relatos y refelexiones desde algunas experiencias de organización en los territorios",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1a2W_6TSWeJOnHSr0Y0UCEmqMYmN1gq8m/view?usp=drive_link"
  },
  {
    "Nombre": "Manejo de los recursos hídricos para áreas de secano",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1CTMV2-5CStzQrQgT_ucYrvEg7vkvNhMR/view?usp=drive_link"
  },
  {
    "Nombre": "Manual de diseño y contrucción de pequeñas presas",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1d9lia2tamxsCe_PXhx3p64uYntnPmPTH/view?usp=drive_link"
  },
  {
    "Nombre": "Determinación y parámetros morfométricos en cuencas implementando SIG",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1S2N10_8ABfANXh-Ca_Jde5RL36yX8H_v/view?usp=drive_link"
  },
  {
    "Nombre": "Caudales ecológicos conceptos, métodos e interpretaciones",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1MdRPeHsIeDX5n0rUgo29i9SABOsIxOGu/view?usp=drive_link"
  },
  {
    "Nombre": "Manual técnico de cálculo de caudales ambientales",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/11tO_6-6a3bgXJ91Y0fzRVYxw98ySK_bC/view?usp=drive_link"
  },
  {
    "Nombre": "Guía básica para la caracterización morfométrica de cuencas hidrográficas",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1WQVCPN_3QXDqjitB0I3ZeGh9aKuop1J7/view?usp=drive_link"
  },
  {
    "Nombre": "Pequeños embalses de uso agrícola",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1frO4rZ_8O-te7p0unSCBi9jnSG4L27rs/view?usp=drive_link"
  },
  {
    "Nombre": "Apuntes de libro de hidrología forestal - Azagra navarro",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/15dPBYsK6X6TfyuGDyU03QvWqpsztv42X/view?usp=drive_link"
  },
  {
    "Nombre": "Bio ingeniería en ambito fluvial",
    "Materia": "HIDRÁULICA",
    "Link": "https://drive.google.com/file/d/1dnbvy5kofZTI_9CKCZtFAyBLTqkb5ml3/view?usp=drive_link"
  },
  {
    "Nombre": "Técnicas de mejoramiento genético de árboles forestales",
    "Materia": "MEJORAMIENTO GENÉTICO",
    "Link": "https://drive.google.com/file/d/1u7hSKVRgJ5ym0ZxK3AhDcvLilZvif0dK/view?usp=drive_link"
  },
  {
    "Nombre": "Mejora genética forestal operativa",
    "Materia": "MEJORAMIENTO GENÉTICO",
    "Link": "https://drive.google.com/file/d/1O_MflfrIQuM8fvmKZKyywtWnEN0gpmoG/view?usp=drive_link"
  },
  {
    "Nombre": "Biología de los microorganismos",
    "Materia": "MICROBIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1jCVl30ZlD5QHp4UToENkcEDlxemKPabF/view?usp=drive_link"
  },
  {
    "Nombre": "Microbiología agrícola",
    "Materia": "MICROBIOLOGÍA",
    "Link": "https://drive.google.com/file/d/1Nq86oCWvB0SYZIwsxgH5lHgoOTyN1-9M/view?usp=drive_link"
  },
  {
    "Nombre": "manual de métodos básicos de muestreo y análisis en ecologia vegetal",
    "Materia": "MUESTREO",
    "Link": "https://drive.google.com/file/d/1jcPaSnAWg2LSYVvbfyD0Xkk7DPV3JEIa/view?usp=drive_link"
  },
  {
    "Nombre": "SD-27: Muestreo y técnicas de evaluación de vegetación y fauna",
    "Materia": "MUESTREO",
    "Link": "https://drive.google.com/file/d/1Tk7LclWxrmwPWIkYewuIYMy5q1qvLwQK/view?usp=drive_link"
  },
  {
    "Nombre": "El enfoque de los sistemas",
    "Materia": "ORDENACIÓN",
    "Link": "https://drive.google.com/file/d/134aHZNlmdT4l5lgiuXwevrj8vHT68tyT/view?usp=drive_link"
  },
  {
    "Nombre": "Mensura forestal",
    "Materia": "ORDENACIÓN",
    "Link": "https://drive.google.com/file/d/190zZpN1faBCBMiIQzD0kVTfI1p0QuuOT/view?usp=drive_link"
  },
  {
    "Nombre": "Propagación de plantas",
    "Materia": "PROPAGACIÓN",
    "Link": "https://drive.google.com/file/d/10R1dE2WM0MRTZKDXUuYhcZlz_BwXXAaJ/view?usp=drive_link"
  },
  {
    "Nombre": "Química Inorgánica Unidad V",
    "Materia": "QUÍMICA INORGÁNICA",
    "Link": "https://drive.google.com/file/d/1XUTUEIqmJ0V5Hz-VOrdGcvzgep-iJTtf/view?usp=drive_link"
  },
  {
    "Nombre": "Diapositivas química",
    "Materia": "QUÍMICA INORGÁNICA",
    "Link": "https://drive.google.com/file/d/1aYahd-CyAwkneL_KdhWQqAOcoIgGA9mT/view?usp=drive_link"
  },
  {
    "Nombre": "Química: estructura, comportamiento y transformaciones de la materia",
    "Materia": "QUÍMICA INORGÁNICA",
    "Link": "https://drive.google.com/file/d/1ZkQx2V8DXYt1HOJ4QwSiBwRTCD131RkQ/view?usp=drive_link"
  },
  {
    "Nombre": "Fundamentos de física y química",
    "Materia": "QUÍMICA INORGÁNICA",
    "Link": "https://drive.google.com/file/d/1h1Hsu6STMDNJHW3ul1aRw6a1wu9AhzIb/view?usp=drive_link"
  },
  {
    "Nombre": "SD-06: Guía de estudio de química genera e inorgánica",
    "Materia": "QUÍMICA INORGÁNICA",
    "Link": "https://drive.google.com/file/d/15kqZsndPLyi1ZN8NMdOXzs97BCyFdJzh/view?usp=drive_link"
  },
  {
    "Nombre": "Fundamentos de química . Burns",
    "Materia": "QUÍMICA INORGÁNICA",
    "Link": "https://drive.google.com/file/d/1hh-gZZpss3KPnlwHwEyGKD_U9W-BaSzc/view?usp=drive_link"
  },
  {
    "Nombre": "Química general - Chang",
    "Materia": "QUÍMICA INORGÁNICA",
    "Link": "https://drive.google.com/file/d/1vSnX60zaxruhEvbhwflMjplI_4wI_Fxr/view?usp=drive_link"
  },
  {
    "Nombre": "Química orgánica - Hart",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1m57OJqkY3mkpCOGb6ntzzVetQik1PtJt/view?usp=drive_link"
  },
  {
    "Nombre": "Bioquímica - Bohinski",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1Qoj96dvDgsEiRR6JSQineCk3pMbir5x8/view?usp=drive_link"
  },
  {
    "Nombre": "Química orgánica - Bailey",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1LEVutr2lN2SyoQhZPrDCFOCb-kG2yI2l/view?usp=drive_link"
  },
  {
    "Nombre": "Química orgánica - Alonso Cebeira",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1jb-rvKd1iw5DFFJb3_dzKjfeIHzb7qJG/view?usp=drive_link"
  },
  {
    "Nombre": "Qúímica orgánica - Wade - Vol 2",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/14_6jQrvQ2druI_-zgnK5ywG8jk3rgtJ6/view?usp=drive_link"
  },
  {
    "Nombre": "Qúímica orgánica - Wade - Vol 1",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1up8nEbzHtjHM03_yGIvkpk4bEqyrPn_g/view?usp=drive_link"
  },
  {
    "Nombre": "Química ambiental",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1BymxnDmeu13fZjWGfGCCQ_uAJr5lXyVA/view?usp=drive_link"
  },
  {
    "Nombre": "SD-32: Esteroquímica básica",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1V6r2n8Nzv8VbocYqwVbABwT9LroVo9UH/view?usp=drive_link"
  },
  {
    "Nombre": "SD-35: Guía teórico práctica de ejercicos de química orgánica",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1igYJvTCYZA9UWo138hfFzTw5ZcvSUg3O/view?usp=drive_link"
  },
  {
    "Nombre": "Sd-44: Cromatografía",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1IcHQnqUQbYs-Uk3E1_FMZhqepxXcchvp/view?usp=drive_link"
  },
  {
    "Nombre": "SD-36: Guía teórico práctica de química biológica",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1l5pr2Z2K55sSsMZrlqPVDgcOTFKG8Fmo/view?usp=drive_link"
  },
  {
    "Nombre": "SD-18: Guía de trabajos prácticos",
    "Materia": "QUÍMICA ORGÁNICA",
    "Link": "https://drive.google.com/file/d/1Qti9jg1XDgHJiAjwdygMyPNE7hd3ouf_/view?usp=drive_link"
  },
  {
    "Nombre": "Salud, Seguridad e higiene ambiental",
    "Materia": "SALUD E HIGIENE",
    "Link": "https://drive.google.com/file/d/108xp_K5dwBxRCSWvSeF-iYv02-O8qeSW/view?usp=drive_link"
  },
  {
    "Nombre": "Diapositivas SIG",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/drive/folders/1T0ALETtdlZOC5jKRzi7lJmsgfiNAOa2U?usp=drive_link"
  },
  {
    "Nombre": "Prácticos Teledetección",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/drive/folders/1cTDzG8iHTVaiCFTVWxS5Tzarx-c40pgf?usp=drive_link"
  },
  {
    "Nombre": "Tecnología de los Sistemas de Información geográfica",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1YmTsgH2VZkDBERnLKFRblmJbZaNk9myU/view?usp=drive_link"
  },
  {
    "Nombre": "Sistemas de información geográfica - Joaquin Sendra",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1d9E4_hkE4rz2Bq8iWxzq_MdLsWC4W2o_/view?usp=drive_link"
  },
  {
    "Nombre": "Introducción a la fotogrametría",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/13bfvyZneZd4v8D3jZ83AnYuKoooi99-W/view?usp=drive_link"
  },
  {
    "Nombre": "SIGs y evaluación multicriterio en la ordenación territorial",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1MDj9dpr3uPWYfJ0wzAZlJ7GAgctCb0Pt/view?usp=drive_link"
  },
  {
    "Nombre": "SIG Victor Olaya - Tomo II",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1mHJX_ochrJAIF3ExIULvteklEksn01z5/view?usp=drive_link"
  },
  {
    "Nombre": "SIG Victor Olaya - Tomo I",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1VZfKb1ljog05WZ5CHGCmv8EHZ8OcpItX/view?usp=drive_link"
  },
  {
    "Nombre": "SIGs Victor Olaya ",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1_Yx8NHUIiLl2dlncC_u6_vwW1Hu_XiET/view?usp=drive_link"
  },
  {
    "Nombre": "SD-24: SIG 1",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1VJs1XJX8sKNivkNPloVbbtjXKqUXSQvz/view?usp=drive_link"
  },
  {
    "Nombre": "SD-25: SIG 2",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1SzVYnsN4eor7rc5QrYd_p9MgtcO-7M0s/view?usp=drive_link"
  },
  {
    "Nombre": "SD-26: SIG 3",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1cM9ypFB_nNivb8TTzLl4w3hbMbqhT7d_/view?usp=drive_link"
  },
  {
    "Nombre": "SD-3:GPS",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/16OfyCNsD8ykJfVw-76B8gFTp2-CTfJb6/view?usp=drive_link"
  },
  {
    "Nombre": "SD-4: GLONASS",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/13KVyGGfPfN4ykXhlHqzFnt5e5CErwGSg/view?usp=drive_link"
  },
  {
    "Nombre": "SD.29: nociones de cartografía",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1Q0LPuRLQnbyYc8RTwqDTyPdGi0OOOmgK/view?usp=drive_link"
  },
  {
    "Nombre": "SD-33: principios de teledetección",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/18GZzGdhZ2-AOmWgV-7ssuXJwVk1bU-S8/view?usp=drive_link"
  },
  {
    "Nombre": "SD-34: Plataformas orbitales y sensores",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1YmvaNHwkFyBMmfwge-GpI-12R8imOmk-/view?usp=drive_link"
  },
  {
    "Nombre": "SD-54: transformación de imágenes satelitales",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1r_OrJWuSN1klLdH9fP_36PdSi5vDZD9N/view?usp=drive_link"
  },
  {
    "Nombre": "Sistemas de información geográfica - Alono Sarria",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1qDCWkv_hcA8vGkTa4Wv3ybilqHnMGat7/view?usp=drive_link"
  },
  {
    "Nombre": "Fundamentos de teledetección -  chuvieco",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/175D2deHemYsZQjgtvPAew3SALYQ755Rn/view?usp=drive_link"
  },
  {
    "Nombre": "Fundamentos de teledetección -  chuvieco",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/1u9HWZqN6jp6J_0st7R4bja6csBUDogCA/view?usp=drive_link"
  },
  {
    "Nombre": "La fotografía aérea y su aplicación a estudios geológicos",
    "Materia": "TELEDETECCIÓN Y SIG",
    "Link": "https://drive.google.com/file/d/19jz7JL2iYPnYPijynM7_St3wibCmee_A/view?usp=drive_link"
  },
  {
    "Nombre": "Toxicología ambiental - Duffus",
    "Materia": "TOXICOLOGÍA",
    "Link": "https://drive.google.com/file/d/1DmZIPYSNM2vB5F2OJCcYDMrOaEHzyhYM/view?usp=drive_link"
  },
  {
    "Nombre": "Problemas resueltos de contaminación ambiental",
    "Materia": "TOXICOLOGÍA",
    "Link": "https://drive.google.com/file/d/1MRYlfbEng33Iaai5rZgNM008ue6iqF33/view?usp=drive_link"
  },
  {
    "Nombre": "Toxicología ambiental - Rosero y López",
    "Materia": "TOXICOLOGÍA",
    "Link": "https://drive.google.com/file/d/1lMzy1mMtJBzK9ZTsGhr0s89nc47mLRJS/view?usp=drive_link"
  },
  {
    "Nombre": "Introducción a la química ambiental",
    "Materia": "TOXICOLOGÍA",
    "Link": "https://drive.google.com/file/d/1KosC36b_Bw8p7vc1oIeko2pjlXc6PYWr/view?usp=drive_link"
  },
  {
    "Nombre": "Contaminación ambiental -  una visión desde la química",
    "Materia": "TOXICOLOGÍA",
    "Link": "https://drive.google.com/file/d/1lA-pyRgdGom0ubJrJx8EMm9A9HWlQVix/view?usp=drive_link"
  },
  {
    "Nombre": "Ecología contaminación medioambiente",
    "Materia": "TOXICOLOGÍA",
    "Link": "https://drive.google.com/file/d/1uqMVeAw3BSqa-NO4dQdAmOqkQ6bw26l3/view?usp=drive_link"
  },
  {
    "Nombre": "Zoología General .  Storer y Usinger",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1WkiTpXDqjNnMojYMAqYXJ4FB48vdmuGG/view?usp=drive_link"
  },
  {
    "Nombre": "Bases para la evaluacipon de fauna",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1gyuxbhVy8ZLVZ85MIeXEe-rUQaa0TIqZ/view?usp=drive_link"
  },
  {
    "Nombre": "Manejo de fauna silvestre y desarrollo rural",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1SeqsRRruGTunWu1aEuYWXsZ8GQTK7r4r/view?usp=drive_link"
  },
  {
    "Nombre": "Especies amenazadas - fauna santiagueña",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1EqRLv2g-psLM0PkNQz4exVLU6UCeTFZJ/view?usp=drive_link"
  },
  {
    "Nombre": "Manual para el censo de los vertebrados terrestres",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1SVK8YRSG2mqwU9PibXrpcZ_2xzd3vnZn/view?usp=drive_link"
  },
  {
    "Nombre": "Los que se van",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1vYrsf4knjzqLdv3mxUt4cmgU2QOW4skS/view?usp=drive_link"
  },
  {
    "Nombre": "La fauna griga. Especies introducidas en la Argentina",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/12JOYztERRRapqqMi8ST9fMNeyTg925iT/view?usp=drive_link"
  },
  {
    "Nombre": "El ñandu",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1ztyNeuanAGVjq8WNl-bSXyjPiafNEtB6/view?usp=drive_link"
  },
  {
    "Nombre": "Medicina en quelonios y otros reptiles",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1kEJYh0ex88BV2U8F_4bfBhSxKmqakDA6/view?usp=drive_link"
  },
  {
    "Nombre": "Los mamíferos silvestres de la provincia de misiones",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1MaDSEHKHM8rK6NIm2o84TXf6f4zuDClM/view?usp=drive_link"
  },
  {
    "Nombre": "Inventario biológico argentino",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1squEpF_CIcZqjphbnwjYhI1ROG26WxTG/view?usp=drive_link"
  },
  {
    "Nombre": "El aguará guazú",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1ggQWnydCx5OMNyA4GMRRxq8xMeK1n_X-/view?usp=drive_link"
  },
  {
    "Nombre": "Dos decadas de trabajo con especies amenzadas de la argentina",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1UQ8dtzHP_3kpzJqsAAKB0m9RmX9fiPaK/view?usp=drive_link"
  },
  {
    "Nombre": "Anfibios y reptiles",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1CZ5vlXiVmRP9hqgUm65p9uLSz0d4qxfn/view?usp=drive_link"
  },
  {
    "Nombre": "Monumentos naturales nacionales y pronvinciales",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1AX6ksMlys1RBdb7HI0K0xN6_LpO6FaEl/view?usp=drive_link"
  },
  {
    "Nombre": "Tarantulas de Argentina",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1qDnwLmwtBKcbsTK4oFd2JihHSDJc6CO7/view?usp=drive_link"
  },
  {
    "Nombre": "Aves de la ciudad de Santiago del Estero -  especies comunes en la época estival",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1Pdr01UPWB7fKyOhbE_cNgw1M0mWBvK8f/view?usp=drive_link"
  },
  {
    "Nombre": "Guía de los mamíferos marinos del golfo de san matias",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1pUbivRIQ0YGa04prwIqFCKNdLqSLmsIx/view?usp=drive_link"
  },
  {
    "Nombre": "Aves de Santiago del Estero - Coria",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1GciUB5MGDUWZXu6RRPI0DWWRfhqnzzZq/view?usp=drive_link"
  },
  {
    "Nombre": "Zoología General. Wegner",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1ELHHrPuMxcpCfGEc89hH8hcIAdcm-tW-/view?usp=drive_link"
  },
  {
    "Nombre": "Manejo de fauna silvestre en la Argentina",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1LPUGF9sYsQ53BjG6Ftpync17IlLHZYc7/view?usp=drive_link"
  },
  {
    "Nombre": "Fauna y sociendad en Argentina",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1nFW38-vICVTAyDKHXL-nKjnnZ42ZXKia/view?usp=drive_link"
  },
  {
    "Nombre": "100 mamíferos de la argentina",
    "Materia": "ZOOLOGÍA",
    "Link": "https://drive.google.com/file/d/1Rb7t1y97TOO5iCxc9EYo8ImSAHwa0y6a/view?usp=drive_link"
  }
];